import { Typography } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { FC } from 'react';
import { TribeAccountType } from 'src/api/circles';
import { MuiSelect } from 'src/components/material/MuiSelect';
import styles from './Members.module.scss';

type SelectOption = {
  value: string;
  label: string;
};

const MEMBER_OPTIONS: SelectOption[] = Array.from({ length: 148 }, (_, i) => ({
  value: (i + 1).toString(),
  label: (i + 1).toString(),
}));

interface MembersProps {
  value: number;
  accountType?: TribeAccountType;
  setValue: (event: SelectChangeEvent) => void;
}

export const Members: FC<MembersProps> = ({ value, accountType, setValue }) => {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <div className={styles.title}>Members</div>
        {/* <a
          href="/how-it-works#members-info"
          target="_blank"
          rel="noopener noreferrer"
        >
          <InfoOutlinedIcon style={{ color: 'red', cursor: 'pointer' }} />
        </a> */}
      </div>
      <div className={styles.description}>
        Set the maximum number of Members you wish to admit to your Circle now.
        You can admit more Members later.
      </div>
      {accountType === TribeAccountType.FIXED && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ textAlign: 'left', fontStyle: 'italic', fontSize: '0.75rem' }}
        >
          Note: Updates to fixed type circles may take some time to process.
        </Typography>
      )}
      <div className={styles.wrapper}>
        <MuiSelect
          label="Members"
          value={value.toString()}
          options={MEMBER_OPTIONS}
          onChange={setValue}
        />
        <div className={styles.titleSelect}>Members</div>
      </div>
      <div className={styles.charactersLength}>
        Choose a number from 1 to 148
      </div>
    </div>
  );
};

export default Members;
